import { useState, ChangeEventHandler, useEffect } from "react";
import { safeJsonParse } from "@cede/utils";
import { StoreMethodMetaData, WidgetConfigMetaData } from "../../../constants/methods";
import { useParamsForms } from "../../../hooks/useParamsForms/useParamsForms";
import { TextField } from "@mui/material";

type JsonFieldProps = {
  method: StoreMethodMetaData | WidgetConfigMetaData;
};

function countLines(str: string) {
  return str.split(/\r\n|\r|\n/).length;
}

export const JsonField = ({ method }: JsonFieldProps) => {
  const { form, setForm } = useParamsForms((state) => ({
    form: state.forms[method.methodName],
    setForm: state.setForm,
  }));
  const [content, setContent] = useState<string>("");

  const onChange: ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    const updatedContent = e.target.value;
    setContent(updatedContent);

    const parsed = safeJsonParse(updatedContent);

    if (parsed) {
      setForm(method.methodName, parsed);
    }
  };

  useEffect(() => {
    setContent(JSON.stringify(form, null, 4));
  }, [form]);

  return (
    <TextField
      inputProps={{
        "data-testid": `json-field-${method.methodName}`,
      }}
      label="Parameters"
      multiline
      rows={countLines(content)}
      value={content}
      onChange={onChange}
    />
  );
};
